import Link from "next/link";
import { Trans } from "next-i18next";

import { EMAIL_SUPPORT } from "@/constants";

import LinkInternal from "../../elements/LinkInternal";
import { InterpolationType } from "../types";

export const getPreviewQuestions = ({ list }) =>
  list.filter(({ preview }) => Boolean(preview));

const getComponent = (tag: string) => {
  switch (tag) {
    case "article":
      return (href: string, content: string) => (
        <LinkInternal href={href}>{content}</LinkInternal>
      );
    default:
      return (href: string, content: string) => (
        <Link href={href} target={"_blank"}>
          {content}
        </Link>
      );
  }
};

export const getInterpolatedString = (
  text: string,
  components: InterpolationType[]
) => {
  const interpolations = {};

  components.map(({ tag, href, content }) => {
    const component = getComponent(tag);
    switch (tag) {
      case "br":
        interpolations[tag] = <br />;
        return;
      case "list":
        interpolations[tag] = <ul />;
        return;
      case "item":
        interpolations[tag] = <li />;
        return;
      case "bold":
        interpolations[tag] = <strong />;
        return;
      default:
        interpolations[tag] = component(href, content);
        return;
    }
  });

  return <Trans components={interpolations}>{text}</Trans>;
};

export const Contact = () => (
  <Trans
    ns={"faq"}
    i18nKey={"intro"}
    components={{
      email: getComponent("email")(`mailto:${EMAIL_SUPPORT}`, EMAIL_SUPPORT),
    }}
  />
);
